import Promise from 'bluebird';
import JsZip from 'jszip';
import FileSaver from 'file-saver';

function download(urls) {
    console.log(urls)
    urls.forEach(url => {
        window.open(url);
    });
  }

export default download;